<div class="row tAC">
    <b class="fs13">Quiere reiniciar la sesión?</b>
    <br/>
    <br/>
    <h1 class="fsfw" >No se requiere autorización de sesión después del reinicio. No se perderían datos de sesión ni mensajes..</h1>
    <h1 class="fsfw">La sesión no estará disponible durante aproximadamente un minuto..</h1>
</div>
<p-divider></p-divider>
<div class="row mt-20">
    <button pButton pRipple type="button" label="Reiniciar sesión" icon="pi pi-refresh" class="p-button-raised p-button-primary p-button-text fR"></button>
    <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times" class="p-button-raised p-button-secondary p-button-text" (click)="sendCRM()"></button>
</div>